import service from "@/utils/request";

export interface holidayAddEmitInter {
  title: string;
  start_time: number;
  end_time: number;
  stop_type: number;
  remark?: string;
  class_ids?: number[];
  holiday_id?: number;
}
// 添加假期
export const holidayAddApi = (data: holidayAddEmitInter) => {
  return service({
    url: "/api/v1/holiday/add",
    method: "post",
    data,
  });
};
// 假期列表
export const holidayListApi = (params: { page: number; page_size: number }) => {
  return service({
    url: "/api/v1/holiday/list",
    method: "get",
    params,
  });
};
// 假期详情
export const holidayDetailApi = (params: { holiday_id: number }) => {
  return service({
    url: "/api/v1/holiday/detail",
    method: "get",
    params,
  });
};
// 编辑假期
export const holidayEditApi = (data: holidayAddEmitInter) => {
  return service({
    url: "/api/v1/holiday/edit",
    method: "post",
    data,
  });
};
// 删除假期
export const holidayDelApi = (params: { holiday_id: number }) => {
  return service({
    url: "/api/v1/holiday/del",
    method: "get",
    params,
  });
};
